import React, { useState, useEffect } from "react";
import leftTree from "../../assets/images/left-tree.png";
import righttree from "../../assets/images/right-tree.png";
import Slider from "react-slick";
import ReactPlayer from "react-player";
import Modal from "react-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faPlay } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchVideos } from "../../features/videoSlice";

const Videos = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const dispatch = useDispatch();

  const { videos, status, error } = useSelector((state) => state.videoslice);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchVideos());
    }
  }, [dispatch, status]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1320,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const openModal = (videoLink) => {
    setSelectedVideo(videoLink);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedVideo(null);
  };

  return (
    <>
      {videos && videos.length > 0 ? (
        <div className="videos-bg  pb-40">
          <div className="container">
            <div className="row" style={{ justifyContent: "center" }}>
              <div className="col-xl-5 col-lg-5 col-lg-4  main-heading-inner-box">
                <div className="inner-box">
                  <img
                    src={leftTree}
                    alt="img"
                    className="heading-left-image"
                  />
                  <h3 className="main-heading-1">Videos</h3>
                  <img
                    src={righttree}
                    alt="img"
                    className="heading-right-image"
                  />
                </div>
              </div>
            </div>

            <div className="row" style={{ overflow: "hidden" }}>
              <Slider {...settings}>
                {videos.map((item, index) => (
                  <div className="video-padding" key={index}>
                    <ReactPlayer
                      url={item.you_tube_video_link}
                      playing={false}
                      controls={false}
                      width="100%"
                      height="200px"
                      muted={true}
                      config={{
                        youtube: {
                          playerVars: {
                            rel: 0, // prevents related videos at the end
                            modestbranding: 1, // hides the YouTube logo
                            disablekb: 1, // disables the keyboard controls
                          },
                        },
                      }}
                    />
                    <div
                      className="background-layer"
                      onClick={() => openModal(item.you_tube_video_link)}
                    >
                      <FontAwesomeIcon icon={faPlay} />
                      <h6 className="mb-0">{item.title}</h6>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>

            <Modal
              isOpen={showModal}
              onRequestClose={closeModal}
              contentLabel="Video Modal"
              style={{
                overlay: { backgroundColor: "rgba(0, 0, 0, 0.8)" },
                content: {
                  top: "50%",
                  left: "50%",
                  right: "auto",
                  bottom: "auto",
                  marginRight: "-50%",
                  transform: "translate(-50%, -50%)",
                  width: "80%",
                  height: "60%",
                },
              }}
            >
              <button
                onClick={closeModal}
                style={{
                  backgroundColor: "#638221",
                  color: "#fff",
                  padding: "5px 10px",
                  float: "right",
                  marginBottom: "10px",
                }}
              >
                <FontAwesomeIcon icon={faXmark} />
              </button>
              {selectedVideo && (
                <ReactPlayer
                  url={selectedVideo}
                  width="100%"
                  height="100%"
                  playing
                  controls
                  config={{
                    youtube: {
                      playerVars: {
                        modestbranding: 1, // Hide YouTube logo
                        rel: 0, // Prevent related videos from showing after the video ends
                        showinfo: 0, // Hide video info (like title)
                        disablekb: 1, // Disable keyboard controls
                        controls: 1,
                      },
                    },
                  }}
                />
              )}
            </Modal>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Videos;
